<template>
  <div class="process-edit-container">
	<div class="ls-card ls-release__header">
	  <el-page-header @back="$router.go(-1)" :content="formTitle"></el-page-header>
	</div>
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ formTitle }}</span>
        <div class="header-actions">
          <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
          <el-button v-if="isEdit" type="success" @click="handleSaveAndDesign">
            保存并设计
          </el-button>
        </div>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="流程编号" prop="definition_no">
              <el-input
                v-model="form.definition_no"
                placeholder="自动生成"
                :disabled="isEdit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="流程名称" prop="definition_name">
              <el-input
                v-model="form.definition_name"
                placeholder="请输入流程名称"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="工单类型" prop="work_order_type">
              <el-select
                v-model="form.work_order_type"
                placeholder="请选择工单类型"
                style="width: 100%"
              >
                <el-option v-for="typeItem in workOrderTypes" :key="typeItem.value" :label="typeItem.label" :value="typeItem.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-form-item label="流程描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入流程描述"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="是否激活">
                <el-switch
                  v-model="form.is_active"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
        <!-- <el-card shadow="never" class="config-card">
          <div slot="header">流程配置</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="是否默认流程">
                <el-switch
                  v-model="form.is_default"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否激活">
                <el-switch
                  v-model="form.is_active"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="允许跳过节点">
                <el-switch
                  v-model="form.allow_skip"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="超时时间(小时)" prop="timeout_hours">
                <el-input-number
                  v-model="form.timeout_hours"
                  :min="0"
                  :max="720"
                  placeholder="0表示不超时"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="超时动作" prop="timeout_action">
                <el-select
                  v-model="form.timeout_action"
                  placeholder="请选择超时动作"
                  style="width: 100%"
                >
                  <el-option label="自动通过" :value="1" />
                  <el-option label="自动驳回" :value="2" />
                  <el-option label="提醒" :value="4" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card> -->

        <!-- <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            maxlength="500"
            show-word-limit
          />
        </el-form-item> -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { apiProcessDefinitionDetail, apiProcessDefinitionAdd, apiProcessDefinitionEdit } from '@/api/service'

export default {
  name: 'ProcessEdit',

  data () {
    return {
      form: {
        definition_no: '',
        definition_name: '',
        order_type: null,
        description: '',
        approval_type: 1,
        is_default: 0,
        is_active: 1,
        allow_skip: 0,
        allow_rollback: 1,
        timeout_hours: null,
        timeout_action: 1,
        remark: ''
      },

      rules: {
        definition_no: [
          { required: true, message: '请输入流程编号', trigger: 'blur' }
        ],
        definition_name: [
          { required: true, message: '请输入流程名称', trigger: 'blur' },
          { max: 100, message: '长度不超过100个字符', trigger: 'blur' }
        ],
        approval_type: [
          { required: true, message: '请选择审批类型', trigger: 'change' }
        ],
        timeout_hours: [
          { type: 'number', message: '必须为数字值', trigger: 'blur' }
        ],
        timeout_action: [
          { required: true, message: '请选择超时动作', trigger: 'change' }
        ]
      },

      saving: false,
      isEdit: false,
      processId: null,
      isViewMode: false,

      workOrderTypes: [
        { value: 1, label: '维修/安装' },
        { value: 2, label: '搬家保洁/回收' }
      ]
    }
  },

  computed: {
    formTitle () {
      if (this.isViewMode) return '流程详情'
      if (this.isEdit) return '编辑流程'
      return '新增流程'
    }
  },

  mounted () {
    this.initPage()
  },

  methods: {
    // 初始化页面
    initPage () {
      this.processId = this.$route.query.id
      this.isViewMode = this.$route.query.view === '1'
      this.isEdit = !!this.processId

      if (this.isEdit) {
        this.loadProcessDetail()
      } else {
        this.generateProcessNo()
      }

      if (this.isViewMode) {
        this.setFormReadonly()
      }
    },

    // 加载流程详情
    async loadProcessDetail () {
      try {
        const res = await apiProcessDefinitionDetail({ id: this.processId })
        this.form = {
          ...this.form,
          ...res
        }
      } catch (error) {
        this.$message.error('加载流程详情失败')
        this.$router.back()
      }
    },

    // 生成流程编号
    generateProcessNo () {
      const timestamp = Date.now()
      const random = Math.floor(Math.random() * 1000)
      this.form.definition_no = `PROC${timestamp}${random}`
    },

    // 设置表单只读
    setFormReadonly () {
      Object.keys(this.form).forEach(key => {
        const rules = this.rules[key]
        if (rules) {
          this.rules[key] = []
        }
      })
    },

    // 保存流程
    async handleSave () {
      try {
        await this.$refs.formRef.validate()

        this.saving = true
        const saveData = { ...this.form }

        if (this.isEdit) {
          saveData.id = this.processId
          await apiProcessDefinitionEdit(saveData)
          // this.$message.success('更新成功')
        } else {
          await apiProcessDefinitionAdd(saveData)
          // this.$message.success('创建成功')
        }

        this.$router.push('/work_order/process/list')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('保存失败:', error)
          // this.$message.error('保存失败')
        }
      } finally {
        this.saving = false
      }
    },

    // 保存并设计
    async handleSaveAndDesign () {
      try {
        await this.$refs.formRef.validate()

        this.saving = true
        const saveData = { ...this.form, id: this.processId }

        await apiProcessDefinitionEdit(saveData)
        // this.$message.success('保存成功')

        this.$router.push({
          path: '/work_order/process/design',
          query: { id: this.processId }
        })
      } catch (error) {
        if (error !== 'cancel') {
          console.error('保存失败:', error)
          // this.$message.error('保存失败')
        }
      } finally {
        this.saving = false
      }
    },

    // 取消
    handleCancel () {
      this.$confirm('确定放弃编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back()
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.process-edit-container {
  padding: 20px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-actions {
      display: flex;
      gap: 10px;
    }
  }

  .config-card {
    margin-bottom: 20px;

    ::v-deep .el-card__header {
      padding: 10px 20px;
      background: #f5f7fa;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
